import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import '../assets/styles/PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Privacy Policy</title>
        <meta name="description" content="Read RFF Cargo’s privacy policy to understand how we handle your data." />
      </Helmet>
      <section className="privacy-policy-section py-5">
        <div className="container">
          <h2 className="privacy-title fw-bold mb-4">Privacy Policy</h2>
          <p className="privacy-description">
            At RFF Cargo, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, share, and protect your data when you interact with our services, including our website and logistics operations.
          </p>
          <h3 className="privacy-section-title fw-bold mb-3">Information We Collect</h3>
          <p className="privacy-text">
            We collect information you provide directly, such as:
          </p>
          <ul className="privacy-list">
            <li>Personal details (e.g., name, email, phone number) when you request a quote or contact us.</li>
            <li>Shipment details (e.g., delivery city, weight, packaging preferences) for processing logistics requests.</li>
            <li>Tracking information when you use our shipment tracking services.</li>
          </ul>
          <p className="privacy-text">
            We may also collect data automatically, such as IP addresses, browser types, and website usage patterns, to improve our services.
          </p>
          <h3 className="privacy-section-title fw-bold mb-3">How We Use Your Information</h3>
          <p className="privacy-text">
            Your information is used to:
          </p>
          <ul className="privacy-list">
            <li>Process and respond to quote requests within 24 hours.</li>
            <li>Facilitate shipment tracking and logistics services.</li>
            <li>Communicate with you about your inquiries or shipments.</li>
            <li>Improve our website and services through analytics.</li>
          </ul>
          <h3 className="privacy-section-title fw-bold mb-3">Data Sharing and Disclosure</h3>
          <p className="privacy-text">
            We may share your information:
          </p>
          <ul className="privacy-list">
            <li>With trusted carriers and logistics partners to fulfill shipments.</li>
            <li>To comply with legal obligations or protect our rights.</li>
            <li>With service providers (e.g., IT support) under strict confidentiality agreements.</li>
          </ul>
          <p className="privacy-text">
            We do not sell your personal information to third parties.
          </p>
          <h3 className="privacy-section-title fw-bold mb-3">Data Security</h3>
          <p className="privacy-text">
            We implement industry-standard security measures, including encryption and access controls, to protect your data from unauthorized access, loss, or misuse. However, no system is completely secure, and we encourage you to safeguard your account credentials.
          </p>
          <h3 className="privacy-section-title fw-bold mb-3">Your Rights</h3>
          <p className="privacy-text">
            You have the right to:
          </p>
          <ul className="privacy-list">
            <li>Access or correct your personal information.</li>
            <li>Request deletion of your data, subject to legal requirements.</li>
            <li>Opt out of marketing communications.</li>
          </ul>
          <p className="privacy-text">
            To exercise these rights, please contact us as outlined below.
          </p>
          <h3 className="privacy-section-title fw-bold mb-3">Contact Information</h3>
          <p className="privacy-text">
            For questions or concerns about this Privacy Policy, please contact us at:
          </p>
          <ul className="privacy-list">
            <li>Email: <a href="mailto:mhareed@rffcargo.co.ke">mhareed@rffcargo.co.ke</a></li>
            <li>Phone: +254 725 222 600</li>
            <li>Visit our <Link to="/contact">Contact Us</Link> page for more options.</li>
          </ul>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;